import { LocalDate } from 'src/utilities/local-date.js';
import type { TaskEvent } from './taskEvent';

export function displayTime(item: TaskEvent): string {
  if (item.time) {
    const string = LocalDate.fromString(item.sortTime).toStringForDisplayWithDayOfWeekAndYear();
    return string[0].toUpperCase() + string.slice(1) + ' ' + item.timeOfDayDisplay;
  }
  return 'Snarest';
}
